<template>
    <td-dialog
        :title="$t('role.AUTH_SET')"
        :before-close="closeAuthTriming"
        :visible.sync="dialogAuthTrimingVisible"
        width="730px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="18vh"
        append-to-body
    >
        <div>
           <el-collapse v-model="activeName" accordion>
                    <el-row>
                        <el-col :span="23">
                            <el-collapse-item name="authSet">
                                <template slot="title" style="padding-left:20px">
                                    <td-checkbox
                                        style="line-height:50px;"
                                        v-model="checkAll"
                                        :ref="checkAll"
                                        @change="
                                            val => {
                                                handleCheckAllChange(val, index, checkgroupData);
                                            }
                                        "
                                    >{{ $t('role.CHECKALL') }}</td-checkbox>
                                </template>
                                <td-checkbox-group
                                    v-if="checkgroupData"
                                    :allList="checkgroupData"
                                    v-model="checkedList"
                                    keys="authId"
                                    text="authName"
                                    @handleCheckedChange="
                                        (val, checkNewest) => {
                                            handleCheckedGroupChange(val, checkNewest, checkgroupData);
                                        }
                                    "
                                ></td-checkbox-group>
                            </el-collapse-item>
                        </el-col>
                    </el-row>
            </el-collapse>
        </div>
        <span slot="footer">
            <td-button type="primary" @click="saveAuthTriming()">{{ $t('common.SAVE') }}</td-button>
            <td-button type="button" @click.native="closeAuthTriming">{{ $t('common.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
export default {
    props: ['dialogAuthTrimingVisible','checkgroupData','authTrimingMap','resTrimingData', 'authCheckedList'],
    created() {
        this.checkedList = this.$util.clone(this.authCheckedList); 
        if (this.checkedList && this.checkedList.length == this.checkgroupData.length) {
            this.checkAll = true;
        } else {
            this.checkAll = false;
        }
        this.newCheckedList = this.checkedList;
    },
    mounted() {},
    // 定义变量
    data() {
        return {
            checkAll:false,
            //默认展开
            activeName:'authSet',
            checkedList:[],
            //最新的选中list
            newCheckedList:[],
        };
    },
    // 定义并实现方法体
    methods: {
        // 关闭窗口之前需要调用的方法
        closeAuthTriming() {
            this.$emit('closeAuthTriming');
        },
        //全选全不选
        handleCheckAllChange(val, index, data) {
            this.checkAll = val;
            this.checkedList = [];
            //全选
            if (val) {
                for (let i = 0; i < data.length; i++) {
                    this.checkedList.push(data[i].authId);
                }
            } else {
                this.checkedList = [];
            }
            this.newCheckedList = this.checkedList;
        },
        handleCheckedGroupChange(val, checkNewest, data) {
            this.newCheckedList = [];
            this.newCheckedList = val;           
        },       
        saveAuthTriming() {
            let rightDataFinetune = new Map();
            rightDataFinetune.set(this.resTrimingData.sResId, this.newCheckedList);
            this.$emit('saveAuthTriming', rightDataFinetune);
            this.closeAuthTriming();
        }
    }
};
</script>
